import { render, staticRenderFns } from "./AdminAlertBar.vue?vue&type=template&id=1d533b10&scoped=true"
import script from "./AdminAlertBar.vue?vue&type=script&lang=js"
export * from "./AdminAlertBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.21_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_tjpztcs3aockkrmwoqc6dtxv4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d533b10",
  null
  
)

export default component.exports